import React from 'react';
import VideoScript, { VideoScriptProps } from '.';
import { BlokComponent } from '../../types/blok.model';

const VideoScriptBlock: BlokComponent<VideoScriptProps> = ({ blok }) => (
  <VideoScript url={blok.url} caption={blok.caption} />
);

export default VideoScriptBlock;
